import React, { useState } from 'react';
import { ArrowLeft, Send, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export default function Questionario() {
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    idadeAdolescente: '',
    email: '',
    descricao: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${API}/questionario`, formData);
      setSubmitted(true);
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (error) {
      console.error('Erro ao enviar questionário:', error);
      alert('Erro ao enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#0a1a2f] via-[#0d2240] to-[#0a1a2f] flex items-center justify-center px-4">
        <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl border-2 border-[#c5a467] text-center max-w-md fade-in-scale">
          <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">Recebemos sua Mensagem!</h2>
          <p className="text-stone-200 text-lg mb-4">
            Obrigada por compartilhar. Entrarei em contato em breve para conversarmos.
          </p>
          <p className="text-[#c5a467] font-semibold">Redirecionando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a1a2f] via-[#0d2240] to-[#0a1a2f] py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-[#c5a467] hover:text-[#d4b574] transition-colors mb-8 fade-in-up"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-semibold">Voltar</span>
        </button>

        <div className="bg-white/10 backdrop-blur-lg p-6 sm:p-8 md:p-12 rounded-3xl border-2 border-[#c5a467] shadow-2xl fade-in-scale">
          <div className="text-center mb-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
              Apresente seu Problema
            </h1>
            <p className="text-stone-200 text-base sm:text-lg">
              Compartilhe sua situação para que eu possa entender melhor como ajudá-lo(a)
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="fade-in-up delay-100">
              <label htmlFor="nome" className="block text-[#c5a467] font-semibold mb-2 text-sm sm:text-base">
                Seu Nome Completo *
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                required
                value={formData.nome}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white/5 border-2 border-[#c5a467]/30 rounded-xl text-white placeholder-stone-400 focus:border-[#c5a467] focus:outline-none transition-all text-sm sm:text-base"
                placeholder="Digite seu nome"
              />
            </div>

            <div className="fade-in-up delay-150">
              <label htmlFor="telefone" className="block text-[#c5a467] font-semibold mb-2 text-sm sm:text-base">
                Seu Telefone/WhatsApp *
              </label>
              <input
                type="tel"
                id="telefone"
                name="telefone"
                required
                value={formData.telefone}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white/5 border-2 border-[#c5a467]/30 rounded-xl text-white placeholder-stone-400 focus:border-[#c5a467] focus:outline-none transition-all text-sm sm:text-base"
                placeholder="(11) 99999-9999"
              />
            </div>

            <div className="fade-in-up delay-200">
              <label htmlFor="idadeAdolescente" className="block text-[#c5a467] font-semibold mb-2 text-sm sm:text-base">
                Idade do Adolescente *
              </label>
              <input
                type="number"
                id="idadeAdolescente"
                name="idadeAdolescente"
                required
                min="10"
                max="25"
                value={formData.idadeAdolescente}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white/5 border-2 border-[#c5a467]/30 rounded-xl text-white placeholder-stone-400 focus:border-[#c5a467] focus:outline-none transition-all text-sm sm:text-base"
                placeholder="Ex: 15"
              />
            </div>

            <div className="fade-in-up delay-300">
              <label htmlFor="email" className="block text-[#c5a467] font-semibold mb-2 text-sm sm:text-base">
                Seu E-mail *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white/5 border-2 border-[#c5a467]/30 rounded-xl text-white placeholder-stone-400 focus:border-[#c5a467] focus:outline-none transition-all text-sm sm:text-base"
                placeholder="seu@email.com"
              />
            </div>

            <div className="fade-in-up delay-400">
              <label htmlFor="descricao" className="block text-[#c5a467] font-semibold mb-2 text-sm sm:text-base">
                Descreva o que está acontecendo *
              </label>
              <textarea
                id="descricao"
                name="descricao"
                required
                rows="6"
                value={formData.descricao}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white/5 border-2 border-[#c5a467]/30 rounded-xl text-white placeholder-stone-400 focus:border-[#c5a467] focus:outline-none transition-all resize-none text-sm sm:text-base"
                placeholder="Conte-me sobre os desafios que você está enfrentando com seu adolescente. Quanto mais detalhes, melhor poderei ajudá-lo(a)."
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#c5a467] to-[#d4b574] text-[#0a1a2f] py-4 rounded-xl font-bold text-base sm:text-lg hover:from-[#d4b574] hover:to-[#e3c481] transition-all shadow-xl hover:shadow-2xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 fade-in-up delay-500"
            >
              {loading ? (
                <span>Enviando...</span>
              ) : (
                <>
                  <Send className="w-5 h-5" />
                  <span>Enviar Mensagem</span>
                </>
              )}
            </button>

            <p className="text-stone-400 text-xs sm:text-sm text-center mt-4">
              Suas informações são confidenciais e serão tratadas com total sigilo profissional.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}